import { DBEntityDependencyErrorType } from '@nu-art/thunderstorm-shared';
import { ModuleFE_XHR } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, Module, asArray } from '@nu-art/ts-common';
import { dispatch_ShowConflictResolution } from '../_dispatchers/index.js';
class ModuleFE_ConflictResolution_Class extends Module {
    conflictResolutionItems = [];
    initDefaultHasDependencyResponse = () => {
        ModuleFE_XHR.setDefaultOnError(async (errorResponse, input, request) => {
            if (errorResponse.errorResponse?.error?.type === DBEntityDependencyErrorType) {
                dispatch_ShowConflictResolution.dispatchUI(errorResponse.errorResponse.error.data);
            }
        });
    };
    showDependencies = (dependencies) => {
        dispatch_ShowConflictResolution.dispatchUI(dependencies);
    };
    registerConflictResolutionItem = (items) => {
        const toAdd = asArray(items);
        toAdd.forEach(item => {
            const existing = this.conflictResolutionItems.find(_item => item.dbKey === _item.dbKey);
            if (existing)
                throw new BadImplementationException(`Conflict resolution item for dbKey ${item.dbKey} already registered!`);
            this.conflictResolutionItems.push(item);
        });
    };
    getConflictResolutionItem = (dbKey) => {
        return this.conflictResolutionItems.find(item => item.dbKey === dbKey);
    };
    getConflictResolutionItemMap = () => {
        return this.conflictResolutionItems.reduce((map, item) => {
            map[item.dbKey] = item;
            return map;
        }, {});
    };
}
export const ModuleFE_ConflictResolution = new ModuleFE_ConflictResolution_Class();
//# sourceMappingURL=ModuleFE_ConflictResolution.js.map